<template>
  <div style="border: solid 1px #999; padding: 10px; margin-top: 10px">
    <div style="display: flex; align-items: center">
      <el-form
          ref="form"
          v-if="
          formData.lessonContentTemplate &&
          formData.lessonContentTemplate.question
        "
          :model="formData"
          size="mini"
          label-width="90px"
          style="width: 100%"
      >
        <el-form-item label="内容形式:" prop="subjectType">
          <el-radio-group
              v-model="formData.lessonContentTemplate.question.type"
              style="margin-left: 30px"
              :disabled="formData.addType=='view'"
          >
            <el-radio
                v-for="item in subjectTypeArr"
                :key="item.value"
                :label="item.value"
                v-show="dialogTitle!=='随堂测试'||item.value!=='text'"
            >{{ item.label }}
            </el-radio>
          </el-radio-group>
        </el-form-item>

        <div
            v-if="
            formData.lessonContentTemplate.question.type === 'select' ||
            formData.lessonContentTemplate.question.type === 'multipleSelect' ||
            formData.lessonContentTemplate.question.type === 'judge' ||
            formData.lessonContentTemplate.question.type === 'sort' ||
            formData.lessonContentTemplate.question.type === 'text'
          "
            class="unShowStar"
        >
          <el-form-item label="习题题干:">
            <div class="titleContentWrapper">
              <div class="titleContentWrapperPreview">
                <MultiContentComponent
                    :inputItems="formatTitleItems"
                ></MultiContentComponent>
              </div>
              <div class="divMultiContentComponentOp">
                <el-button class="mccoEditTextBtn" size="mini" type="primary" @click="handleSingleEditTitle"
                >单项输入
                </el-button>
                <el-button class="mccoEditBtn" size="mini" type="primary" @click="handleMultiEditTitle"
                >组合输入
                </el-button>
              </div>
            </div>
          </el-form-item>
        </div>

        <template
            v-if="
            formData.lessonContentTemplate.question.type === 'select' ||
            formData.lessonContentTemplate.question.type === 'multipleSelect' ||
            formData.lessonContentTemplate.question.type === 'sort'
          "
        >
          <el-form-item label="选项数量" prop="optionNum">
            <el-select
                style="width: 100%"
                v-model="optionNum"
                placeholder="请选择选项数量"
                @change="handleSelectOptionNum"
                :disabled="formData.addType=='view'"
            >
              <el-option
                  v-for="item in selectNumOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item
              v-for="(item, index) in formData.lessonContentTemplate.question
              .type === 'sort'
              ? sortItemOptions
              : selectItemOptions"
              :key="item.value"
              :label="
              (formData.lessonContentTemplate.question.type === 'sort'
                ? ''
                : '选项') + item.label
            "
          >
            <div class="contentWrapper">
              <div class="contentWrapperPreview">
                <MultiContentComponent
                    :inputItems="formatItems[index]"
                ></MultiContentComponent>
              </div>
              <div class="divMultiContentComponentOp">
                <el-button
                    :data-key="item.value" class="mccoEditTextBtn" size="mini" type="primary"
                    @click="handleSingleEditOption(index)"
                    :disabled="formData.addType=='view'"
                >单项输入
                </el-button>
                <el-button :data-key="item.value" class="mccoEditBtn" size="mini" type="primary"
                           @click="handleMultiEditOption(index)"
                           :disabled="formData.addType=='view'"
                >组合输入
                </el-button>
              </div>
            </div>
          </el-form-item>
        </template>

        <!--单选题-->
        <template
            v-if="formData.lessonContentTemplate.question.type === 'select'"
        >
          <el-form-item
              label="正确选项"
              prop="lessonContentTemplate.question.answer[0]"
          >
            <el-select
                style="width: 100%"
                v-model="formData.lessonContentTemplate.question.answer[0]"
                placeholder="请选择正确选项"
                @change="handleSelectAnswer"
                :disabled="formData.addType=='view'"
            >
              <el-option
                  v-for="item in selectItemOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </template>

        <template
            v-if="formData.lessonContentTemplate.question.type === 'judge'"
        >
          <el-form-item
              label="正确选项"
              prop="lessonContentTemplate.question.answer[0]"
          >
            <el-select
                style="width: 100%"
                v-model="formData.lessonContentTemplate.question.answer[0]"
                placeholder="请选择正确选项"
                @change="handleSelectAnswer"
                :disabled="formData.addType=='view'"
            >
              <el-option
                  v-for="item in judgeTrueOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </template>

        <template
            v-if="
            formData.lessonContentTemplate.question.type === 'multipleSelect'
          "
        >
          <el-form-item
              label="正确选项"
              prop="lessonContentTemplate.question.answer[0]"
          >
            <el-checkbox-group
                v-model="formData.lessonContentTemplate.question.answer"
                :disabled="formData.addType=='view'"
            >
              <el-checkbox
                  v-for="item in selectItemOptions"
                  :key="item.value"
                  :label="item.value"
              >
                {{ item.label }}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </template>

        <template
            v-if="formData.lessonContentTemplate.question.type === 'sort'"
        >
          <el-form-item label="正确顺序" class="sortBox">
            <el-input
                type="text"
                v-model="sortTrueAnswer"
                placeholder="请输入正确的排列顺序，示例：4,2,3,1"
                :disabled="formData.addType=='view'"
            ></el-input>
          </el-form-item>
        </template>
        <template
            v-if="formData.lessonContentTemplate.question.type === 'text'"
        ></template>
        <template v-if="dialogTitle=='随堂测试'">
          <el-form-item label="答案解析:">
            <div class="titleContentWrapper">
              <div class="titleContentWrapperPreview">
                <MultiContentComponent
                    :inputItems="formatExplainItems"
                ></MultiContentComponent>
              </div>

              <div class="divMultiContentComponentOp">
                <el-button class="mccoEditTextBtn" size="mini" type="primary" @click="handleSingleEditExplain"
                           :disabled="formData.addType=='view'"
                >单项输入
                </el-button>
                <el-button class="mccoEditBtn" size="mini" type="primary" @click="handleMultiEditExplain"
                           :disabled="formData.addType=='view'"
                >组合输入
                </el-button>
              </div>
            </div>
          </el-form-item>
        </template>
      </el-form>
    </div>
    <MultiContentModal
        @refreshInputVal="refreshInputVal"
        :inputValArr="inputValArr"
    ></MultiContentModal>

    <ContentPickModal
        :materialInfo="materialInfo"
        @refreshMaterial="refreshMaterial"
    ></ContentPickModal>
  </div>
</template>

<script>
import ContentPickModal from "./ContentPickModal.vue";
import MultiContentModal from "./MultiContentModal.vue";
import MultiContentComponent from "./MultiContentComponent.vue";
import {mapMutations} from "vuex";
import {SUBJECT_TYPE} from "@/utils/constants";
import dialog from "element-ui/packages/dialog";

export default {
  name: "LessonContentSubject",
  components: {ContentPickModal, MultiContentModal, MultiContentComponent},
  data() {
    let questionType = Object.keys(SUBJECT_TYPE).map((key) => {
      return {
        value: key,
        label: SUBJECT_TYPE[key],
      };
    });

    return {
      materialInfo: null,
      optionNum: 4,
      editMode: "title",
      editIndex: -1,
      inputValArr: [],
      formatItems: [],
      formatTitleItems: [],
      formatExplainItems: [],
      subjectTypeArr: [...questionType],
      formData: {},
      sortTrueAnswer: null,
      selectNumOptions: [
        {label: "2", value: 2},
        {label: "3", value: 3},
        {label: "4", value: 4},
        {label: "5", value: 5},
        {label: "6", value: 6},
        {label: "7", value: 7},
        {label: "8", value: 8},
        {label: "9", value: 9},
        {label: "10", value: 10},
      ],
      selectItemOptions: [],
      sortItemOptions: [],
      //判断题
      judgeTrueOptions: [
        {
          label: "对",
          value: 0,
        },
        {
          label: "错",
          value: 1,
        },
      ],
    };
  },
  props: {
    dialogTitle: {
      type: String,
      default() {
        return null;
      },
    }
  },
  methods: {
    ...mapMutations("courseCenter", ["setData"]),
    initFormData(data) {
      this.formData = JSON.parse(JSON.stringify(data));
      let itemLength = this.formData.lessonContentTemplate.question.item.length;
      this.optionNum = itemLength ? itemLength : this.optionNum;
      this.handleSelectOptionNum();

      let materialMap = {};
      this.formData.lessonContentTemplate.materials.map((x) => {
        materialMap[x.id] = x;
      });
      let ids = this.formData.lessonContentTemplate.question.title;
      this.formatTitleItems =
          ids == "" ? [] : ids.split(",").map((id) => {
            return {
              contentPattern: materialMap[id]?.type,
              lessonContentTemplate: {
                material: materialMap[id],
              },
            };
          });
      let explain = this.formData.lessonContentTemplate.question.explain;
      this.formatExplainItems = explain === "" ? [] : explain.split(",").map((id) => {
        return {
          contentPattern: materialMap[id].type,
          lessonContentTemplate: {
            material: materialMap[id],
          },
        };
      });

      this.sortTrueAnswer = this.formData.lessonContentTemplate.question.answer.join(",");
    },
    getFormData() {
      let tmp = JSON.parse(JSON.stringify(this.formData));
      tmp.sortTrueAnswer = this.sortTrueAnswer;
      if (tmp.sortTrueAnswer != null && tmp.sortTrueAnswer.length > 0) {
        tmp.sortTrueAnswer = tmp.sortTrueAnswer.replaceAll("，", ",");
      }
      return tmp;
    },
    refreshMaterial(material) {
      this.refreshInputVal([material]);
    },
    doSingleEdit(ids) {
      let materialMap = {};
      this.formData.lessonContentTemplate.materials.map((x) => {
        materialMap[x.id] = x;
      });
      this.inputValArr =
          ids === "" ? [] : ids.split(",").map((x) => {
            return {
              contentPattern: materialMap[x].type,
              lessonContentTemplate: {material: materialMap[x]},
            };
          });

      if (this.inputValArr.length > 0) {
        this.materialInfo = this.inputValArr[0];
      } else {
        this.materialInfo = null;
      }
      this.setData({key: "contentPickModalVisible", value: true});
    },
    doMultiEdit(ids) {
      let materialMap = {};
      this.formData.lessonContentTemplate.materials.map((x) => {
        materialMap[x.id] = x;
      });
      this.inputValArr =
          ids == ""
              ? []
              : ids.split(",").map((x) => {
                return {
                  contentPattern: materialMap[x]?.type,
                  lessonContentTemplate: {material: materialMap[x]},
                };
              });
      this.setData({key: "multiContentModalVisible", value: true});
    },
    handleSingleEditTitle() {
      this.editMode = "title";
      this.editIndex = 0;
      let ids = this.formData.lessonContentTemplate.question.title;
      this.doSingleEdit(ids);
    },
    handleMultiEditTitle() {
      this.editMode = "title";
      let ids = this.formData.lessonContentTemplate.question.title;
      this.doMultiEdit(ids);
    },
    handleSingleEditExplain() {
      this.editMode = "explain";
      this.editIndex = 0;
      let ids = this.formData.lessonContentTemplate.question.explain;
      this.doSingleEdit(ids);
    },
    handleMultiEditExplain() {
      this.editMode = "explain";
      this.editIndex = 0;
      let ids = this.formData.lessonContentTemplate.question.explain;
      this.doMultiEdit(ids);
    },
    handleSingleEditOption(index) {
      this.editMode = "option";
      this.editIndex = index;
      let ids = this.formData.lessonContentTemplate.question.item[index];
      this.doSingleEdit(ids);
    },
    handleMultiEditOption(index) {
      this.editMode = "option";
      this.editIndex = index;
      let ids = this.formData.lessonContentTemplate.question.item[index];
      this.doMultiEdit(ids);
    },
    handleSelectOptionNum() {
      let arr = [];
      let sort_arr = [];
      let item_arr = [];
      let format_item_arr = [];
      let materialMap = {};
      this.formData.lessonContentTemplate.materials.map((x) => {
        materialMap[x.id] = x;
      });
      let itemLength = this.formData.lessonContentTemplate.question.item.length;
      for (let i = 0; i < this.optionNum; i++) {
        arr.push({label: "ABCDEFGHIJK"[i], value: i});
        sort_arr.push({label: i + 1, value: i});

        if (i < itemLength) {
          item_arr.push(this.formData.lessonContentTemplate.question.item[i]);
          if (this.formData.lessonContentTemplate.question.item[i] === "") {
            format_item_arr.push([]);
          } else {
            let arr = this.formData.lessonContentTemplate.question.item[i]
                .split(",").map((x) => {
                  x += ""
                  return {
                    contentPattern: materialMap[x]?.type,
                    lessonContentTemplate: {material: materialMap[x]},
                  };
                });
            format_item_arr.push(arr);
          }
        } else {
          item_arr.push("");
          format_item_arr.push([]);
        }
      }
      this.selectItemOptions = arr;
      this.sortItemOptions = sort_arr;
      this.formData.lessonContentTemplate.question.item = item_arr;
      this.formatItems = format_item_arr;
    },
    handleSelectAnswer() {
    },
    refreshInputVal(items) {
      let materialMap = {};
      this.formData.lessonContentTemplate.materials.map((x) => {
        materialMap[x.id] = x;
      });

      items.map((x) => {
        let material = x.lessonContentTemplate.material;
        if (materialMap[material.id] == undefined) {
          this.formData.lessonContentTemplate.materials.push(material);
        } else {
          for (let i = 0; i < this.formData.lessonContentTemplate.materials.length; i++) {
            if (this.formData.lessonContentTemplate.materials[i].id == material.id) {
              this.formData.lessonContentTemplate.materials[i] = material;
            }
          }
        }
        materialMap[material.id] = material;
      });
      let ids = items
          .map((x) => {
            return x.lessonContentTemplate.material.id;
          })
          .join(",");
      if (this.editMode == "title") {
        this.formData.lessonContentTemplate.question.title = ids;
        this.formatTitleItems = items.map((x) => {
          return {
            contentPattern:
            materialMap[x.lessonContentTemplate.material.id].type,
            lessonContentTemplate: {
              material: materialMap[x.lessonContentTemplate.material.id],
            },
          };
        });
      } else if (this.editMode == "explain") {
        this.formData.lessonContentTemplate.question.explain = ids;
        this.formatExplainItems = items.map((x) => {
          return {
            contentPattern:
            materialMap[x.lessonContentTemplate.material.id].type,
            lessonContentTemplate: {
              material: materialMap[x.lessonContentTemplate.material.id],
            },
          };
        });
      } else {
        this.formData.lessonContentTemplate.question.item[this.editIndex] = ids;
        this.formatItems.splice(
            this.editIndex,
            1,
            items.map((x) => {
              return {
                contentPattern:
                materialMap[x.lessonContentTemplate.material.id].type,
                lessonContentTemplate: {
                  material: materialMap[x.lessonContentTemplate.material.id],
                },
              };
            })
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.contentWrapper {
  width: 100%;
  height: 120px;
  display: flex;

  .contentWrapperPreview {
    width: 100%;
    height: 120px;
    border: solid 1px #ddd;
    overflow-y: auto;
  }
}

.titleContentWrapper {
  width: 100%;
  height: 320px;
  display: flex;

  .titleContentWrapperPreview {
    width: 100%;
    height: 320px;
    border: solid 1px #ddd;
    overflow-y: auto;
  }
}

.divMultiContentComponentOp {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: end;

  .mccoEditBtn {
    height: 48%;
    width: 80px;
  }

  .mccoEditTextBtn {
    height: 48%;
    width: 80px;
  }
}
</style>
